
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cmkWO", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $kVysQ = parcelRequire("kVysQ");


var $6CEg5 = parcelRequire("6CEg5");


var $7Sm4c = parcelRequire("7Sm4c");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5vi32 = parcelRequire("5vi32");


var $3jwuS = parcelRequire("3jwuS");


var $lJlG6 = parcelRequire("lJlG6");

/* MainLayoutComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");


var $irOoi = parcelRequire("irOoi");


var $T1bCI = parcelRequire("T1bCI");


var $aPmQM = parcelRequire("aPmQM");


var $hrAmX = parcelRequire("hrAmX");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $eSLr0 = parcelRequire("eSLr0");


var $5ZPtT = parcelRequire("5ZPtT");

/**
 * @generated SignedSource<<aee3d452e700222c207ed3413b38e9d4>>
 * @relayHash b1c5bff520163b91e48e77e975abc312
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 808594c60ce4834378741a27b78d1f8617da8c6d03a72504d9df4572dc06ca47
const $4a82a81af9c5e51c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "theme",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "themeKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "b1c5bff520163b91e48e77e975abc312",
            "id": "808594c60ce4834378741a27b78d1f8617da8c6d03a72504d9df4572dc06ca47",
            "metadata": {},
            "name": "useATLGeneralWebPanelObserverSpaceThemeQuery",
            "operationKind": "query",
            "text": "query useATLGeneralWebPanelObserverSpaceThemeQuery($spaceKey:String){space(key:$spaceKey){id,theme{themeKey}}}"
        }
    };
}();
$4a82a81af9c5e51c$var$node.hash = "5414d0003b526de29b97ae12c29148ab";
var $4a82a81af9c5e51c$export$2e2bcd8739ae039 = $4a82a81af9c5e51c$var$node;






var $jSnXV = parcelRequire("jSnXV");








var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $edacfc52aca854e0$export$58b315702afd1f24 = (contentType)=>{
    return contentType === 'page' || contentType === 'blogpost';
};



var $iHLZT = parcelRequire("iHLZT");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");


var $jMyy4 = parcelRequire("jMyy4");


var $dS3n9 = parcelRequire("dS3n9");

/**
 * Parse connect app scripts width and height, and preset connect apps dimention
 * before iframe gets injected, to avoid connect apps iframe causing layout shift
 * up and down multiple times
 *
 * Return total height of connect apps rendered in a location
 * @param container - The HTMLElement contains connect apps
 * @returns {number | undefined} - Returns total height of connect apps rendered in the container
 */ const $bd143360dd0cf955$export$a25046a8b24b3fc6 = (container, isEarlyInitIframe = false)=>{
    if (!document || !container) return;
    // Get all connect-app scripts at container, there can be multiple ones
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Total height of connect-app wrapper
    let totalHeight = 0;
    const parsePx = (matchedVal)=>{
        // Parse % or px
        let addPx = '';
        if (matchedVal.indexOf('%') === -1 && matchedVal.indexOf('px') === -1) addPx = 'px';
        return addPx;
    };
    allScripts.forEach((iframeScript)=>{
        // Get connect-app script html
        const scriptHtml = iframeScript?.innerHTML || '';
        if (scriptHtml) {
            const scriptWrapper = iframeScript.parentNode;
            // Extract connect-app height
            const matchedHeight = scriptHtml.match(/"h":\s*"(\d+(?:%|px)?)"/);
            const matchedHeightVal = matchedHeight?.[1];
            if (matchedHeightVal) {
                const matchedInt = parseInt(matchedHeightVal);
                // Add this connect-app height to total height
                if (typeof matchedInt === 'number') totalHeight += matchedInt;
                // Preset connect-app wrapper height before iframe is injected
                // NOTE: We don't want to set width or height, in case iframe is early initialized.
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.height = matchedHeightVal + parsePx(matchedHeightVal);
            } else // If unable to extract height value, default to 0 during iframe loading to prevent jumping,
            // this will eventually be removed after connect apps are fully loaded.
            if (!isEarlyInitIframe) scriptWrapper.style.height = '0px';
            // Extract connect-app width
            const matchedWidth = scriptHtml.match(/"w":\s*"(\d+(?:%|px)?)"/);
            const matchedWidthVal = matchedWidth?.[1];
            if (matchedWidthVal) // Preset connect-app wrapper height before iframe is injected
            // NOTE: We don't want to set width or height, in case iframe is early initialized.
            {
                if (!isEarlyInitIframe && scriptWrapper) scriptWrapper.style.width = matchedWidthVal + parsePx(matchedWidthVal);
            }
        }
    });
    return totalHeight;
};
const $bd143360dd0cf955$export$a2ff9656ed51a40a = (container, timeout = false)=>{
    if (!document || !container) return;
    const appStatus = [];
    const allScripts = container.querySelectorAll('script.ap-iframe-body-script');
    if (!allScripts || allScripts.length === 0) return;
    // Remove each connect-app wrapper preset width and height after iframe loaded
    allScripts.forEach((iframeScript)=>{
        // Get connect-app parent
        const scriptWrapper = iframeScript.parentNode;
        const iframeLoaded = !!scriptWrapper.querySelector('iframe');
        const statusIndicator = scriptWrapper.querySelector('.ap-status-indicator');
        const timeoutIndicator = scriptWrapper.querySelector('.ap-load-timeout');
        const statusIndicatorHidden = statusIndicator?.style.display === 'none';
        // Check connect app loading status
        const isAppLoaded = iframeLoaded && (statusIndicatorHidden || timeoutIndicator);
        // Store each iframe's loading status
        appStatus.push(isAppLoaded);
        // If iframe is loaded, remove preset width and height
        if (isAppLoaded || timeout) {
            if (scriptWrapper?.style.height) scriptWrapper.style.height = '';
            if (scriptWrapper?.style.width) scriptWrapper.style.width = '';
        }
    });
    // Return if all connect apps are loaded
    return appStatus.every((status)=>status === true);
};
const $bd143360dd0cf955$export$e36afaf5515aa43 = 10000;


const $9739cc17e95eb22c$export$8610b0674aff537e = (isViewPage, isEdit)=>{
    const [{ contentId: contentId, spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)({
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: 'cache-first',
        spaceKey: spaceKey,
        contentId: contentId
    });
    const fixedATLGeneralWebPanelRef = (0, $42omo.useRef)(null);
    const allAppsLoaded = (0, $42omo.useRef)(false);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const presetTimeoutConfig = (0, $1xpoY.default).getNumber('confluence_webpanel_preset_dimension_time', 0);
    const heightUpdateThreshold = (0, $1xpoY.default).getNumber('confluence_webpanel_update_height_threshold', 0);
    // For Nav 3, we expand atl.general panel to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage
    // For Nav 4, the side nav is always present, so we have an additional check on isNav4Enabled in FixedWebPanelWrapper
    const isFullWidth = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const shouldShowATLGeneralWebPanel = panels.length > 0;
    if (shouldShowATLGeneralWebPanel && (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)) {
        (0, $iHLZT.superbatchJSRecorder).includeConnectWebResources();
        (0, $iHLZT.superbatchCSSRecorder).includeConnectWebResources();
    }
    // Determines if panels should not display a UI element and only allow for the support of scripts and analytics
    const shouldHidePanels = !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType) && contentType;
    // Fixed behavior should be consistent for all pages as the same header is used for live / edit as well
    const canFixOnEditOrLivePage = isViewPage || isEdit || isLivePage;
    // If the other conditions for a fixed web panel are true, check whether the space is themed
    // The web panel should not be fixed for themed spaces since they do not have a fixed page header
    const canFixATLGeneralWebPanel = shouldShowATLGeneralWebPanel && canFixOnEditOrLivePage;
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $4a82a81af9c5e51c$export$2e2bcd8739ae039), {
        skip: !canFixATLGeneralWebPanel,
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "@confluence/web-panel-location"
    });
    const isATLGeneralWebPanelFixed = canFixATLGeneralWebPanel && data?.space?.theme === null;
    const isAdvancedSearch = routeDataRef.current?.routeName === (0, $1NBp8.ADVANCED_SEARCH).name;
    // ResizeObserver is needed because the height of web panel items can change at any time
    const resizeObserver = (0, $42omo.useMemo)(()=>{
        if (!renderServerPlaceholder) {
            const callback = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(([entry])=>{
                if (entry) {
                    // Remove each connect app preset dimension until all apps are loaded
                    if (!allAppsLoaded.current) allAppsLoaded.current = !!(0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(entry.target);
                    // Only reset container height after all connect apps are loaded,
                    // to prevent layout shift jumping up and down
                    if (allAppsLoaded.current) {
                        let newHeight = entry.target.clientHeight;
                        if (Boolean(window.__SSR_RENDERED__) && heightUpdateThreshold > 0 && !isAdvancedSearch) {
                            const initialHeight = window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] || 0;
                            const currentHeight = entry.target.clientHeight || 0;
                            // Ignore height changes that are less than the threshold
                            if (Math.abs(currentHeight - initialHeight) <= heightUpdateThreshold) newHeight = initialHeight;
                        }
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${newHeight}px`);
                        const detail = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: newHeight
                            }
                        } : undefined;
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail));
                    }
                }
            }, 100);
            return new ResizeObserver(callback);
        }
    }, [
        renderServerPlaceholder,
        heightUpdateThreshold,
        isAdvancedSearch
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        const fixedATLGeneralWebPanel = fixedATLGeneralWebPanelRef.current;
        let appLoadTimeoutId;
        let presetTimeoutId;
        if (!renderServerPlaceholder && isATLGeneralWebPanelFixed && fixedATLGeneralWebPanel) {
            // Handle content types that have web panel hidden, some content types have web panel hidden,
            // so it don't need to preset wrapper dimension.
            if (shouldHidePanels) {
                document.documentElement.style.setProperty('--atl-general-webpanel-height', `0px`);
                const detail_0 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                    detail: {
                        height: 0
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_0));
            } else {
                const totalHeight = (0, $bd143360dd0cf955$export$a25046a8b24b3fc6)(fixedATLGeneralWebPanel, (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false));
                if (totalHeight) {
                    document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
                    const detail_1 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                        detail: {
                            height: totalHeight
                        }
                    } : undefined;
                    document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_1));
                }
                // If after max wait time, connect apps are still not loaded, then remove preset dimensions
                appLoadTimeoutId = setTimeout(()=>{
                    if (!allAppsLoaded.current) {
                        (0, $bd143360dd0cf955$export$a2ff9656ed51a40a)(fixedATLGeneralWebPanel, true);
                        allAppsLoaded.current = true;
                        const connectAppsWrapperContainer = fixedATLGeneralWebPanel;
                        const containerHeight = connectAppsWrapperContainer?.clientHeight || 0;
                        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${containerHeight}px`);
                        const detail_2 = (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false) ? {
                            detail: {
                                height: containerHeight
                            }
                        } : undefined;
                        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated', detail_2));
                    }
                }, (0, $bd143360dd0cf955$export$e36afaf5515aa43));
            }
        }
        if (isATLGeneralWebPanelFixed) {
            // If the page is SSR rendered and the initial height is set,
            // preserve the initial height a little bit longer until apps height become stable
            if (Boolean(window.__SSR_RENDERED__) && !isAdvancedSearch) presetTimeoutId = setTimeout(()=>{
                fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
            }, presetTimeoutConfig);
            else fixedATLGeneralWebPanel && resizeObserver?.observe(fixedATLGeneralWebPanel);
        }
        return ()=>{
            if (isATLGeneralWebPanelFixed) fixedATLGeneralWebPanel && resizeObserver?.unobserve(fixedATLGeneralWebPanel);
            if (appLoadTimeoutId) clearTimeout(appLoadTimeoutId);
            if (presetTimeoutConfig && presetTimeoutId) clearTimeout(presetTimeoutId);
        };
    }, [
        shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed,
        resizeObserver,
        renderServerPlaceholder,
        shouldHidePanels,
        presetTimeoutConfig,
        isAdvancedSearch
    ]);
    return {
        shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel,
        isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
        fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef,
        isCompanyHub: isCompanyHub,
        isFullWidth: isFullWidth,
        shouldHidePanels: shouldHidePanels
    };
};



var $9Z1sw = parcelRequire("9Z1sw");


var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");



























var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");

const $062cf5e7a1742c3e$export$a6ca923c8089e1e8 = (isViewPage, isNav4Enabled, isEdit)=>{
    const [{ spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { extensions: extensions } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER)
    });
    // For Nav 3, we expand the banner to full width when the side nav is not present. This is the case for
    // company hub and when url has mode=global, such as on custom homepage.
    // For Nav 4, the side nav is always present - so the banner is never full width)
    const isSideNavPresent = isNav4Enabled || (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) || routeDataRef.current?.queryParams?.mode === 'global';
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef } = $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper(isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef,
        isForgePageBannerFullWidth: isSideNavPresent,
        shouldHideForgePageBanner: contentType && !(0, $edacfc52aca854e0$export$58b315702afd1f24)(contentType)
    };
};
const $062cf5e7a1742c3e$var$useForgePageBannerObserverHelper = (0, $3u0dr.isReactCompilerActiveV2)() ? (isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit)=>{
    const $ = (0, $frIzR.c)(10);
    const fixedForgePageBannerRef = (0, $42omo.useRef)(null);
    const isForgePageBannerFixed = isViewPage && !isLivePage && !isEdit && extensions.length > 0;
    let t0;
    bb0: {
        if (!renderServerPlaceholder) {
            let t1;
            if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
                t1 = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))($062cf5e7a1742c3e$var$_temp, 100));
                $[0] = t1;
            } else t1 = $[0];
            t0 = t1;
            break bb0;
        }
        t0 = undefined;
    }
    const resizeObserver = t0;
    let t1;
    if ($[1] !== isForgePageBannerFixed || $[2] !== resizeObserver) {
        t1 = ()=>{
            const fixedForgePageBanner = fixedForgePageBannerRef.current;
            if (isForgePageBannerFixed) fixedForgePageBanner && resizeObserver?.observe(fixedForgePageBanner);
            return ()=>{
                fixedForgePageBanner && resizeObserver?.unobserve(fixedForgePageBanner);
            };
        };
        $[1] = isForgePageBannerFixed;
        $[2] = resizeObserver;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== isForgePageBannerFixed || $[5] !== renderServerPlaceholder || $[6] !== resizeObserver) {
        t2 = [
            isForgePageBannerFixed,
            resizeObserver,
            renderServerPlaceholder
        ];
        $[4] = isForgePageBannerFixed;
        $[5] = renderServerPlaceholder;
        $[6] = resizeObserver;
        $[7] = t2;
    } else t2 = $[7];
    (0, $42omo.useLayoutEffect)(t1, t2);
    let t3;
    if ($[8] !== isForgePageBannerFixed) {
        t3 = {
            isForgePageBannerFixed: isForgePageBannerFixed,
            fixedForgePageBannerRef: fixedForgePageBannerRef
        };
        $[8] = isForgePageBannerFixed;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : (isViewPage, isLivePage, renderServerPlaceholder, extensions, isEdit)=>{
    const fixedForgePageBannerRef = (0, $42omo.useRef)(null);
    const isForgePageBannerFixed = isViewPage && !isLivePage && !isEdit && extensions.length > 0; // extensions triggers a re-render
    const resizeObserver = (0, $42omo.useMemo)(()=>{
        if (!renderServerPlaceholder) return new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(([entry])=>{
            if (entry) {
                document.documentElement.style.setProperty('--forge-page-banner-height', `${entry.target.clientHeight}px`);
                const detail = (0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false) ? {
                    detail: {
                        height: entry.target.clientHeight
                    }
                } : undefined;
                document.dispatchEvent(new CustomEvent('forgePageBannerHeightUpdated', detail));
            }
        }, 100));
    }, [
        renderServerPlaceholder
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        const fixedForgePageBanner = fixedForgePageBannerRef.current;
        if (isForgePageBannerFixed) fixedForgePageBanner && resizeObserver?.observe(fixedForgePageBanner);
        return ()=>{
            fixedForgePageBanner && resizeObserver?.unobserve(fixedForgePageBanner);
        };
    }, [
        isForgePageBannerFixed,
        resizeObserver,
        renderServerPlaceholder
    ]);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        fixedForgePageBannerRef: fixedForgePageBannerRef
    };
};
function $062cf5e7a1742c3e$var$_temp(t0) {
    const [entry] = t0;
    if (entry) {
        document.documentElement.style.setProperty("--forge-page-banner-height", `${entry.target.clientHeight}px`);
        const detail = (0, $6mKj3.expVal)("confluence_pgxp_p2m_batch_1", "isEnabled", false) ? {
            detail: {
                height: entry.target.clientHeight
            }
        } : undefined;
        document.dispatchEvent(new CustomEvent("forgePageBannerHeightUpdated", detail));
    }
}






var $7zgzO = parcelRequire("7zgzO");

/* ReturnToMobileComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $aXWIB = parcelRequire("aXWIB");


var $2Nwuj = parcelRequire("2Nwuj");


var $1DWH0 = parcelRequire("1DWH0");


var $68uaC = parcelRequire("68uaC");


var $8dwdz = parcelRequire("8dwdz");


var $jlIaF = parcelRequire("jlIaF");

function $796a872a5806d472$var$_defineProperty(e, r, t) {
    return (r = $796a872a5806d472$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $796a872a5806d472$var$_toPropertyKey(t) {
    var i = $796a872a5806d472$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $796a872a5806d472$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $796a872a5806d472$var$returnLinkContainer = null;
const $796a872a5806d472$export$5945f0cd1996f6fc = (0, $1DWH0.default)()(class ReturnToMobileComponent extends (0, $42omo.PureComponent) {
    componentDidMount() {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const { isSupportedUserAgent: isSupportedUserAgent } = this.state;
        if (isSupportedUserAgent && createAnalyticsEvent) {
            const analyticsData = {
                source: 'mobileWebView',
                action: 'visited',
                actionSubject: 'page'
            };
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: analyticsData
            }).fire();
        }
    }
    isDesktopSwitchRequired() {
        // Port from com.atlassian.confluence.mobile.MobileUtils#isDesktopSwitchRequired
        const { getQueryParams: getQueryParams } = this.props;
        const { desktop: desktop } = getQueryParams();
        return (0, $68uaC.Cookies).get('confluence.mobile.desktop.switch') === 'true' || desktop === 'true';
    }
    render() {
        const { isSupportedUserAgent: isSupportedUserAgent, isDesktopOverride: isDesktopOverride } = this.state; // Only show this if the user is on a mobile device and has explicitly chosen to show desktop
        if (isSupportedUserAgent && isDesktopOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1yt4pxbi _11q7i8nm _y3gn1h6o"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "return-to-mobile.nav.switch.to.mobile.text",
            defaultMessage: "You are viewing the desktop version of Confluence on a mobile supported device."
        }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: this.getSwitchToMobileHref(),
            onClick: this.onSwitchClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "return-to-mobile.nav.switch.to.mobile.action",
            defaultMessage: "Switch to Confluence Mobile"
        })));
        return null;
    }
    constructor(...args){
        super(...args);
        $796a872a5806d472$var$_defineProperty(this, "state", {
            isSupportedUserAgent: (0, $8dwdz.isMobileUserAgent)(),
            // If the mobile SPA is handling mobile view, we need to check local storage
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            isDesktopOverride: this.isDesktopSwitchRequired() || (0, $8dwdz.isDesktopOverrideActive)()
        });
        $796a872a5806d472$var$_defineProperty(this, "onSwitchClick", (event)=>{
            event.preventDefault();
            const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = this.props; // If the backend filter has not set a cookie, we need to remove it from local storage (the new way)
            // TODO: Remove the call to isDesktopSwitchRequired once mobile-plugin is dead
            if (!this.isDesktopSwitchRequired()) (0, $8dwdz.deactivateDesktopOverride)();
            else // Otherwise, we need to remove the cookie
            (0, $68uaC.Cookies).remove('confluence.mobile.desktop.switch', {
                path: (0, $jlIaF.CONTEXT_PATH)
            });
            const queryParams = getQueryParams(); // remove the desktop=true request parameter if it is present
            if (queryParams.desktop === 'true') {
                queryParams.desktop = null; // setQueryParams removes null values
                setQueryParams(queryParams, true);
            } else window.location.reload();
        });
        $796a872a5806d472$var$_defineProperty(this, "getSwitchToMobileHref", ()=>{
            const { getQueryParams: getQueryParams } = this.props;
            const queryParams = getQueryParams();
            const url = new URL(window.location.href);
            if (queryParams.desktop === 'true') url.searchParams.delete('desktop');
             // Resulting URL is same page, non-desktop override
            return url.toString();
        });
    }
});


class $019e7af3f6f4f87e$export$4207093557acd0c0 extends (0, $42omo.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams, setQueryParams: setQueryParams })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $796a872a5806d472$export$5945f0cd1996f6fc), {
                getQueryParams: getQueryParams,
                setQueryParams: setQueryParams,
                ...this.props
            });
        });
    }
}






var $4NX9d = parcelRequire("4NX9d");


var $jln20 = parcelRequire("jln20");





var $9wGTI = parcelRequire("9wGTI");


var $6yagU = parcelRequire("6yagU");





var $8zMP3 = parcelRequire("8zMP3");








var $9HB34 = parcelRequire("9HB34");








function $bd51a8c87efeb5a5$export$cfc1361be0de4203({ noOpSSRInlineScript: noOpSSRInlineScript }) {
    /**
   * Should only inline this script while SSR,
   * not needed on the client side.
   */ // For hydrateRoot there is a mismatch on client for this script.
    // So we want to add the script on client side but guard it with check to
    // not execute logic
    if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) {
        if (!noOpSSRInlineScript) return null;
        else window.__RENDERER_BYPASS_BREAKOUT_SSR__ = true;
    }
    const context = $bd51a8c87efeb5a5$export$92859d13f30c883e();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("script", {
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: context
        }
    });
}
function $bd51a8c87efeb5a5$export$92859d13f30c883e() {
    return `
  (function(window){
		if(typeof window !== 'undefined' && window.__RENDERER_BYPASS_BREAKOUT_SSR__) {
			return;
		}
		${$bd51a8c87efeb5a5$export$47813c4121c8b4b3};
    (${$bd51a8c87efeb5a5$export$a125785b9fe77113.toString()})(breakoutConstsInner, ${(0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)});
  })(window);
 `;
}
const $bd51a8c87efeb5a5$export$47813c4121c8b4b3 = `
	var breakoutConstsInner = {};
  breakoutConstsInner.presetConnectAppsWrapperDimension = ${(0, $bd143360dd0cf955$export$a25046a8b24b3fc6).toString()};
`;
function $bd51a8c87efeb5a5$export$a125785b9fe77113(breakoutConstsInner, isEarlyInitIframe = false) {
    const breakoutContainer = document.querySelector("[data-connect-container='fixed-atl-general-wrapper']");
    if (!breakoutContainer) return;
    const totalHeight = breakoutConstsInner?.presetConnectAppsWrapperDimension(breakoutContainer, isEarlyInitIframe);
    if (totalHeight) {
        document.documentElement.style.setProperty('--atl-general-webpanel-height', `${totalHeight}px`);
        document.dispatchEvent(new CustomEvent('atlGeneralWebPanelHeightUpdated'));
        window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] = totalHeight;
    }
}


/* ForgeApps.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $aJv6Q = parcelRequire("aJv6Q");





var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");








var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");








var $6uUjl = parcelRequire("6uUjl");

const $b7830f7e8969acd1$var$invisible = null;
const $b7830f7e8969acd1$export$afbabe4d2446fca2 = (forgeModules, loading, error)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    }
    return forgeModules.map((0, $aJv6Q.withErrorBoundary)({
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_1e0cglyw"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.BACKGROUND_SCRIPT_APPS_FORGE_EXPERIENCE),
            id: (0, $8a9Dm.getAppId)(app)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.BackgroundScriptForgeApp), {
            app: app,
            // Adding the pageRoute to the extensionData will allow the Forge app to re-render when the route changes
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        })))));
};
const $b7830f7e8969acd1$export$f0362fceef532aae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_BACKGROUND_SCRIPT),
        render: $b7830f7e8969acd1$export$afbabe4d2446fca2
    }); // This is exported solely for testing purposes
const $b7830f7e8969acd1$export$d778357d5618ef80 = (forgeModules, loading, error)=>{
    const [{ contentId: contentId, routeName: routeName, spaceKey: spaceAlias }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    if (loading) return null;
    if (error) {
        if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        return null;
    }
    return forgeModules.map((0, $aJv6Q.withErrorBoundary)({
        attribution: (0, $3IBnw.Attribution).ECOSYSTEM
    })((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            key: (0, $8a9Dm.getAppId)(app),
            attributes: {
                appId: (0, $8a9Dm.getAppId)(app)
            },
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.PageBannerForgeApp), {
            app: app,
            extensionData: {
                type: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
                ...contentId ? {
                    content: {
                        id: contentId,
                        type: (0, $hIaUw.getContentType)(routeName),
                        subtype: isLivePage ? 'live' : null
                    }
                } : {},
                ...spaceKey || spaceAlias ? {
                    space: {
                        id: spaceId,
                        key: spaceKey || spaceAlias
                    }
                } : {}
            }
        }))));
};
const $b7830f7e8969acd1$export$910fc80855ba5fda = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_PAGE_BANNER),
        render: $b7830f7e8969acd1$export$d778357d5618ef80
    });
};


const $4e0d0b830c02a893$export$7292bf0b169ba997 = (0, $aPmQM.createRelayEnvironment)({});
const $4e0d0b830c02a893$var$webPanelWrapperStyles = {
    showPanel: "_1e0c1ule",
    hidePanel: "_1e0cglyw"
};
const $4e0d0b830c02a893$var$contentBodyWrapperStyles = null;
const $4e0d0b830c02a893$var$fixedWebPanelSpacerStyles = null;
const $4e0d0b830c02a893$var$fixedForgeBannerSpacerStyles = null;
const $4e0d0b830c02a893$var$mainContentContainerStyles = {
    default: "_v5641fl4 _2lx2vrvc _1n261g80 _1bsb1osq _18u0ze3t _1s6jaq80",
    addMinWidth: "_1ul9cv93"
};
const $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles = {
    default: "_1e0cglyw _1pby1ial _1bsb1osq _kqsw1n9t _bfhkvuon _1ltv1d4h _p12f18ua",
    showPanel: "_1e0c1ule"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4e0d0b830c02a893$var$ContentBody = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhkvuon _vchhusvi _s7n4jp4b _1tke1wug _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $4e0d0b830c02a893$var$BANNER_STATE_CONTAINERS = [
    (0, $hrAmX.BannerStateContainer)
];
const $4e0d0b830c02a893$var$MainLayoutInnerContent = ({ enableNavigation: enableNavigation = true, disableMinWidth: disableMinWidth, screen: screen, isViewPage: isViewPage = false, isEdit: isEdit, children: children, isLivePage: isLivePage, ommitComponentsNotNeededForPdfExport: ommitComponentsNotNeededForPdfExport, renderServerPlaceholder: renderServerPlaceholder })=>{
    const { shouldShowATLGeneralWebPanel: shouldShowATLGeneralWebPanel, isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed, fixedATLGeneralWebPanelRef: fixedATLGeneralWebPanelRef, shouldHidePanels: shouldHidePanels } = (0, $9739cc17e95eb22c$export$8610b0674aff537e)(isViewPage, isEdit);
    const { isForgePageBannerFixed: isForgePageBannerFixed, fixedForgePageBannerRef: fixedForgePageBannerRef, shouldHideForgePageBanner: shouldHideForgePageBanner } = (0, $062cf5e7a1742c3e$export$a6ca923c8089e1e8)(isViewPage, true, isEdit);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const [enableRightSidebarCSS, setEnableRightSidebarCSS] = (0, $42omo.useState)(false);
    const shouldRenderATLGeneralWebPanel = shouldShowATLGeneralWebPanel && !ommitComponentsNotNeededForPdfExport;
    const shouldOmitATLFooterWebPanel = isEdit || isLivePage || ommitComponentsNotNeededForPdfExport || renderServerPlaceholder;
    const topElementStyle = {};
    if (screen) for(const key in screen){
        if (screen.hasOwnProperty(key)) {
            if (key.startsWith('background')) topElementStyle[key] = screen[key];
        }
    }
    (0, $42omo.useEffect)(()=>{
        if (rightSidebarContext.getCurrent()) setEnableRightSidebarCSS(true);
    }, [
        rightSidebarContext
    ]);
    const AtlGeneralWebPanel = isATLGeneralWebPanelFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: fixedATLGeneralWebPanelRef,
        "data-test-id": "fixed-atl-general-wrapper",
        "data-connect-container": "fixed-atl-general-wrapper",
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHidePanels && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_4t3i1wzo"
        ])
    }), renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bd51a8c87efeb5a5$export$cfc1361be0de4203), {
        noOpSSRInlineScript: renderServerPlaceholder
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-test-id": "atl-general-wrapper",
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: "cache-first"
    }));
    const ForgePageBannerExtensionPoint = isForgePageBannerFixed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-test-id": "fixed-forge-page-banner-wrapper-compiled",
        ref: fixedForgePageBannerRef,
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['default'],
            !shouldHideForgePageBanner && $4e0d0b830c02a893$var$fixedWebPanelWrapperStyles['showPanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7830f7e8969acd1$export$910fc80855ba5fda), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_4t3irbkl"
        ])
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHideForgePageBanner && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7830f7e8969acd1$export$910fc80855ba5fda), null));
    const mainLayoutContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$mainContentContainerStyles['default'],
            !enableRightSidebarCSS && !(disableMinWidth || !enableNavigation) && $4e0d0b830c02a893$var$mainContentContainerStyles['addMinWidth'],
            "confluence-main-content"
        ]),
        "data-test-id": "confluence-main-content",
        "data-vc": "confluence-main-content-compiled"
    }, shouldRenderATLGeneralWebPanel && AtlGeneralWebPanel, ForgePageBannerExtensionPoint, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $019e7af3f6f4f87e$export$4207093557acd0c0), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: $4e0d0b830c02a893$var$BANNER_STATE_CONTAINERS
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                "_16jlidpf _1o9zkb7n _i0dl1wug _19pkidpf _vchhusvi _11rm1hrf _kqswh2mm _1bsb1osq _1e0c1txw _1tken7od"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e0d0b830c02a893$var$ContentBody, {
            "data-test-id": "content-body",
            "data-vc": "content-body-compiled",
            id: "content-body",
            style: topElementStyle
        }, children))), !shouldOmitATLFooterWebPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-test-id": "atl-footer-wrapper",
        className: (0, $gMc0m.default)([
            $4e0d0b830c02a893$var$webPanelWrapperStyles['showPanel'],
            shouldHidePanels && $4e0d0b830c02a893$var$webPanelWrapperStyles['hidePanel']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocation), {
        location: (0, $eSLr0.ATL_FOOTER)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7830f7e8969acd1$export$f0362fceef532aae), null)));
    return children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("style" // eslint-disable-next-line react/no-danger
    , {
        dangerouslySetInnerHTML: {
            __html: `.confluence-main-content .cp-container [role='dialog'] { z-index: 350; }`
        }
    }), mainLayoutContent) : null;
};
const $4e0d0b830c02a893$export$80006b81bf20e108 = (props)=>{
    const { isViewPage: isViewPage = false, isEdit: isEdit } = props;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const browserLocation = typeof globalThis.window?.location !== 'undefined' ? globalThis.window.location : undefined;
    const isPdfExport = browserLocation !== undefined && Boolean((0, $1NBp8.PDF_EXPORT_PAGE).match(browserLocation.pathname));
    const ommitComponentsNotNeededForPdfExport = isPdfExport && (0, $9wGTI.fg)('confluence_fe_omit_unneeded_comps_for_pdf_export');
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let webPanelBatchLocations = [];
    if (!ommitComponentsNotNeededForPdfExport) {
        if (isViewPage || isEdit) webPanelBatchLocations = [
            (0, $eSLr0.ATL_GENERAL),
            (0, $eSLr0.ATL_FOOTER)
        ];
    }
    const shouldRenderWebPanelBatchProvider = webPanelBatchLocations.length > 0 && (0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e0d0b830c02a893$var$MainLayoutInnerContent, {
        ...props,
        isLivePage: isLivePage,
        ommitComponentsNotNeededForPdfExport: ommitComponentsNotNeededForPdfExport,
        renderServerPlaceholder: renderServerPlaceholder
    });
    return shouldRenderWebPanelBatchProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z1sw.WebPanelLocationBatchProvider), {
        locations: webPanelBatchLocations
    }, content) : content;
};
const $4e0d0b830c02a893$export$375787c0d3c11135 = (props)=>{
    const { editorPreloader: editorPreloader, navView: navView, enableNavigation: enableNavigation = true } = props;
    const [preloader, setPreloader] = (0, $42omo.useState)();
    const setEditorPreloader = async ()=>{
        if (editorPreloader) {
            const newPreloader = await editorPreloader();
            setPreloader(newPreloader);
        }
    };
    (0, $42omo.useEffect)(()=>{
        setEditorPreloader(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "default"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4e0d0b830c02a893$export$80006b81bf20e108, props));
    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, enableNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ZPtT.PageLayout), {
        editorPreloader: preloader,
        view: navView
    }, content) : content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4NX9d.PerformanceEnd), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }));
    if ((0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true) || (0, $9wGTI.fg)('navx-global-side-nav-confluence')) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irOoi.RelayEnvironmentProvider), {
        environment: (0, $9wGTI.fg)('cfe_use_confluence_relay_env') ? (0, $9HB34.getRelayEnvironment)() : $4e0d0b830c02a893$export$7292bf0b169ba997
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6yagU.ConfluencePreviewPanelsProvider), null, content));
    return content;
};


const $a171d54840e7d827$export$93af822566053b3e = /*#__PURE__*/ (0, $42omo.memo)(({ spaceKey: spaceKey, isEdit: isEdit, enableNavigation: enableNavigation, isViewPage: isViewPage, ...otherProps })=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { data: data, error: unhandledError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query MainLayoutQuery($spaceKey:String!){space(key:$spaceKey){id lookAndFeel{content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode}}}}}`, {
        variables: {
            // When spaceKey is undefined/falsy the query is skipped, so defaulting it to
            // an empty string doesn't change the logic but merely keeps TypeScript happy.
            spaceKey: spaceKey || ''
        },
        skip: !spaceKey || isEdit || isLivePage
    });
    let error = unhandledError;
    if ((0, $f9jv7.isNotFoundError)(error) || (0, $1uFM6.isUnauthorizedError)(error)) {
        // The MainLayoutQuery only loads the space styling configuration, and neither error nor
        // missing configuration don't break the user experience. Unauthorized or NotFound error
        // (anonymous user, restricted or missing space/page) are handled by children components
        // of MainLayout and are part of the normal user flow, hence these can be safely muted.
        (0, $7Sm4c.markErrorAsHandled)(error);
        error = undefined;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6CEg5.PerformanceStart), {
        subject: (0, $kVysQ.PERFORMANCE_SUBJECT_mainLayout)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4e0d0b830c02a893$export$375787c0d3c11135), {
        ...otherProps,
        enableNavigation: isEmbeddedConfluence || isMobileApp ? false : enableNavigation,
        screen: data?.space?.lookAndFeel?.content?.screen ?? undefined,
        isViewPage: isViewPage,
        isEdit: isEdit
    }));
});
module.exports["MainLayout"] = $a171d54840e7d827$export$93af822566053b3e;

});

parcelRegister("kVysQ", function(module, exports) {
const $35b50a968705ed01$export$9960fc620d4470dd = 'comments';
const $35b50a968705ed01$export$c4d483efe8eba686 = 'link-to-page';
const $35b50a968705ed01$export$1de09ba64e7728f2 = 'main-layout';
const $35b50a968705ed01$export$586856ecee8f0723 = 'manage-watcher-dialog';
const $35b50a968705ed01$export$51f018e0f9f84a74 = 'Navigation';
const $35b50a968705ed01$export$94afb8303c61d07d = 'navigation-fmp';
const $35b50a968705ed01$export$fe596581250cd9fc = 'side-navigation-fmp';
const $35b50a968705ed01$export$88c949ed1e388f68 = 'NavigationView';
const $35b50a968705ed01$export$1a3cc5086fadf289 = 'recent-dropdown';
const $35b50a968705ed01$export$b35db70015797a33 = 'resolved-inline-comments-dialog';
const $35b50a968705ed01$export$5c78998b70cdff69 = 'copy-page-tree';
const $35b50a968705ed01$export$1167e4f56227df4c = 'space-directory';
module.exports["PERFORMANCE_SUBJECT_linkToPage"] = $35b50a968705ed01$export$c4d483efe8eba686;
module.exports["PERFORMANCE_SUBJECT_mainLayout"] = $35b50a968705ed01$export$1de09ba64e7728f2;
module.exports["PERFORMANCE_SUBJECT_manageWatcherDialog"] = $35b50a968705ed01$export$586856ecee8f0723;
module.exports["PERFORMANCE_SUBJECT_navigation"] = $35b50a968705ed01$export$51f018e0f9f84a74;
module.exports["PERFORMANCE_SUBJECT_navigationFMP"] = $35b50a968705ed01$export$94afb8303c61d07d;
module.exports["PERFORMANCE_SUBJECT_sideNavigationFMP"] = $35b50a968705ed01$export$fe596581250cd9fc;
module.exports["PERFORMANCE_SUBJECT_navigationView"] = $35b50a968705ed01$export$88c949ed1e388f68;
module.exports["PERFORMANCE_SUBJECT_resolvedInlineCommentsDialog"] = $35b50a968705ed01$export$b35db70015797a33;
module.exports["PERFORMANCE_SUBJECT_copyPageTree"] = $35b50a968705ed01$export$5c78998b70cdff69;
module.exports["PERFORMANCE_SUBJECT_spaceDirectory"] = $35b50a968705ed01$export$1167e4f56227df4c;

});

parcelRegister("5ZPtT", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5ea117b10605f60a$export$6d1402fb58384e4f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "OP-5u",
    name: "PageLayout",
    loader: async ()=>(await (parcelRequire("91YPm"))).PageLayout
});
module.exports["PageLayout"] = $5ea117b10605f60a$export$6d1402fb58384e4f;

});

parcelRegister("91YPm", function(module, exports) {

let $6933641546ed5196$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6933641546ed5196$var$load("h3ABO"),
    $6933641546ed5196$var$load("3g3jg"),
    $6933641546ed5196$var$load("cEpHL"),
    $6933641546ed5196$var$load("joCF0"),
    $6933641546ed5196$var$load("esywo"),
    $6933641546ed5196$var$load("3Nkqv"),
    $6933641546ed5196$var$load("jkjF5"),
    $6933641546ed5196$var$load("7wBDb"),
    $6933641546ed5196$var$load("2mZ4J"),
    $6933641546ed5196$var$load("6iz6l"),
    $6933641546ed5196$var$load("4SCW2"),
    $6933641546ed5196$var$load("2rRRp"),
    $6933641546ed5196$var$load("aQh37"),
    $6933641546ed5196$var$load("bJVDE"),
    $6933641546ed5196$var$load("4XdkL"),
    $6933641546ed5196$var$load("4eock"),
    $6933641546ed5196$var$load("8k9aB"),
    $6933641546ed5196$var$load("fLwVm"),
    $6933641546ed5196$var$load("fuks3"),
    $6933641546ed5196$var$load("dIjeS"),
    $6933641546ed5196$var$load("jf18J"),
    $6933641546ed5196$var$load("6wr18"),
    $6933641546ed5196$var$load("6oA6x"),
    $6933641546ed5196$var$load("9eStK"),
    $6933641546ed5196$var$load("3w49v"),
    $6933641546ed5196$var$load("6tsCm"),
    $6933641546ed5196$var$load("7cp4y"),
    $6933641546ed5196$var$load("bAAhx"),
    $6933641546ed5196$var$load("fWqYx"),
    $6933641546ed5196$var$load("5Raqr"),
    $6933641546ed5196$var$load("xu7ej"),
    $6933641546ed5196$var$load("juZ3q"),
    $6933641546ed5196$var$load("lnk1B"),
    $6933641546ed5196$var$load("3CBDb"),
    $6933641546ed5196$var$load("gdwbX"),
    $6933641546ed5196$var$load("fFc5s"),
    $6933641546ed5196$var$load("3ezts"),
    $6933641546ed5196$var$load("jbxHq"),
    $6933641546ed5196$var$load("el56J"),
    $6933641546ed5196$var$load("9XYQ9"),
    $6933641546ed5196$var$load("1qlDN"),
    $6933641546ed5196$var$load("1yVM6"),
    $6933641546ed5196$var$load("5pvpJ"),
    $6933641546ed5196$var$load("jbM5v"),
    $6933641546ed5196$var$load("ffEVr"),
    $6933641546ed5196$var$load("dChec"),
    $6933641546ed5196$var$load("kCA52"),
    $6933641546ed5196$var$load("gwwqw"),
    $6933641546ed5196$var$load("761cM"),
    $6933641546ed5196$var$load("kEsSu"),
    $6933641546ed5196$var$load("1bbSu"),
    $6933641546ed5196$var$load("Wowvf"),
    $6933641546ed5196$var$load("1F2Py"),
    $6933641546ed5196$var$load("lJ0p6"),
    $6933641546ed5196$var$load("cjaF7"),
    $6933641546ed5196$var$load("hhss7"),
    $6933641546ed5196$var$load("7EorR"),
    $6933641546ed5196$var$load("gmHzx")
]).then(()=>parcelRequire('48Eol'));

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $aXWIB = parcelRequire("aXWIB");


var $42omo = parcelRequire("42omo");


var $dTb09 = parcelRequire("dTb09");


var $7zIsq = parcelRequire("7zIsq");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = (0, $9wGTI.fg)("forge_attachment_display_conditions") ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    let t3;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== locale || $[3] !== moduleType || $[4] !== queryOptions || $[5] !== resolvedAttachmentId || $[6] !== returnBlockedExtensions || $[7] !== skipQuery || $[8] !== spaceContextOnly || $[9] !== spaceKey) {
        t3 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        });
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = locale;
        $[3] = moduleType;
        $[4] = queryOptions;
        $[5] = resolvedAttachmentId;
        $[6] = returnBlockedExtensions;
        $[7] = skipQuery;
        $[8] = spaceContextOnly;
        $[9] = spaceKey;
        $[10] = t3;
    } else t3 = $[10];
    const options = t3;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t4;
    let t5;
    if ($[11] !== extsError || $[12] !== spaceError) {
        t4 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t5 = [
            extsError,
            spaceError
        ];
        $[11] = extsError;
        $[12] = spaceError;
        $[13] = t4;
        $[14] = t5;
    } else {
        t4 = $[13];
        t5 = $[14];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[15] !== extsData || $[16] !== extsError || $[17] !== extsLoading) {
        t6 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[15] = extsData;
        $[16] = extsError;
        $[17] = extsLoading;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey })=>{
    const { locale: locale } = (0, $aXWIB.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = (0, $9wGTI.fg)('forge_attachment_display_conditions') ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const options = (0, $42omo.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        resolvedAttachmentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $42omo.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $dTb09.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $7zIsq.usePrefilteredExtensionListRelay), (0, $7zIsq.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("kqIWy", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey, t0)=>{
    const $ = (0, $frIzR.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { includeSpaceTypeSettings: t2 } = t1;
    const includeSpaceTypeSettings = t2 === undefined ? false : t2;
    let t3;
    if ($[2] !== includeSpaceTypeSettings || $[3] !== spaceKey) {
        t3 = {
            variables: {
                spaceKey: spaceKey,
                includeSpaceTypeSettings: includeSpaceTypeSettings
            }
        };
        $[2] = includeSpaceTypeSettings;
        $[3] = spaceKey;
        $[4] = t3;
    } else t3 = $[4];
    const options = t3;
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), options);
    let t4;
    if ($[5] !== data || $[6] !== includeSpaceTypeSettings) {
        t4 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path,
            typeSettings: includeSpaceTypeSettings && data.space?.spaceTypeSettings ? {
                enabledContentTypes: {
                    ...data.space.spaceTypeSettings.enabledContentTypes
                }
            } : undefined
        } : undefined;
        $[5] = data;
        $[6] = includeSpaceTypeSettings;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== error || $[9] !== loading || $[10] !== t4) {
        t5 = {
            loading: loading,
            data: t4,
            error: error
        };
        $[8] = error;
        $[9] = loading;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, attachmentId: attachmentId, spaceContextOnly: spaceContextOnly = false })=>{
    const context = spaceContextOnly ? {
        spaceKey: spaceKey
    } : {
        spaceKey: spaceKey,
        contentId: contentId,
        ...attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? {
            attachmentId: attachmentId
        } : {}
    };
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: context,
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("4NX9d", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $42omo = parcelRequire("42omo");


var $9eE57 = parcelRequire("9eE57");

class $6182ff2f7ce21920$export$c7a09306845216e0 extends (0, $42omo.Component) {
    componentDidMount() {
        (0, $9eE57.perfMarkEnd)(this.props);
    }
    render() {
        return null;
    }
}
$6182ff2f7ce21920$export$c7a09306845216e0.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    details: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    includeFeatureFlags: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
$6182ff2f7ce21920$export$c7a09306845216e0.defaultProps = {
    subjectId: '',
    includeFeatureFlags: false
};
module.exports["PerformanceEnd"] = $6182ff2f7ce21920$export$c7a09306845216e0;

});

parcelRegister("jln20", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4BDAe = parcelRequire("4BDAe");


var $gK1lf = parcelRequire("gK1lf");


var $aWwYt = parcelRequire("aWwYt");


var $6mKj3 = parcelRequire("6mKj3");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen && (0, $6mKj3.expValEquals)('confluence_preview_panels_exp', 'isEnabled', true)) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $42omo.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $42omo.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $42omo.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $4BDAe.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $gK1lf.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("gK1lf", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $fN3iy = parcelRequire("fN3iy");

const $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d = (0, $4pOgL.isReactCompilerActivePlatform)() ? (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
} : (panelId)=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5f74c961ecd1fdd3$export$c68e55e6e77f3d5d;

});

parcelRegister("6yagU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $fN3iy = parcelRequire("fN3iy");


var $dj7jL = parcelRequire("dj7jL");


var $9iW1B = parcelRequire("9iW1B");


var $8wJwv = parcelRequire("8wJwv");

// Component that uses the URL change detection hooks inside the provider context
const $8e2f4c2c3b316f28$var$UrlChangeDetector = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    (0, $9iW1B.useClosePreviewPanelOnUrlChange)();
    return null;
} : ()=>{
    (0, $9iW1B.useClosePreviewPanelOnUrlChange)();
    return null; // This component doesn't render anything
};
const $8e2f4c2c3b316f28$export$2b37b625358608ab = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { children: children } = t0;
    const { closeAllPanels: closeAllPanels, closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    let t1;
    if ($[0] !== closeAllPanels) {
        t1 = ()=>{
            closeAllPanels();
        };
        $[0] = closeAllPanels;
        $[1] = t1;
    } else t1 = $[1];
    const onPreviewPanelOpen = t1;
    let t2;
    if ($[2] !== closeOnlyPreviewPanel) {
        t2 = ()=>{
            closeOnlyPreviewPanel();
        };
        $[2] = closeOnlyPreviewPanel;
        $[3] = t2;
    } else t2 = $[3];
    const onPreviewPanelClose = t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e2f4c2c3b316f28$var$UrlChangeDetector, null);
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== children || $[6] !== onPreviewPanelClose || $[7] !== onPreviewPanelOpen) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fN3iy.PreviewPanelsProvider), {
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose,
            parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
        }, t3, children);
        $[5] = children;
        $[6] = onPreviewPanelClose;
        $[7] = onPreviewPanelOpen;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ children: children })=>{
    const { closeAllPanels: closeAllPanels, closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const onPreviewPanelOpen = (0, $42omo.useCallback)(()=>{
        /*
    Any time a Preview Panel is opened in Confluence, we want to close all
    non-preview panel side panels (like the object sidebar) to ensure no panel conflicts.
    */ closeAllPanels();
    }, [
        closeAllPanels
    ]);
    const onPreviewPanelClose = (0, $42omo.useCallback)(()=>{
        // Add any additional logic here for closing preview panels.
        /*
    	Any time a Preview Panel is closed in Confluence, if the type of the previous panel and the
    	next panel are different, we want to close the previous panel before opening the new one. In order to
    	do this we need to pass the preview panel api
    */ closeOnlyPreviewPanel();
    }, [
        closeOnlyPreviewPanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fN3iy.PreviewPanelsProvider), {
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose,
        parentProduct: (0, $dj7jL.PARENT_PRODUCTS).CONFLUENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8e2f4c2c3b316f28$var$UrlChangeDetector, null), children);
};
module.exports["ConfluencePreviewPanelsProvider"] = $8e2f4c2c3b316f28$export$2b37b625358608ab;

});

parcelRegister("9iW1B", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $QU6QS = parcelRequire("QU6QS");


var $8wJwv = parcelRequire("8wJwv");

const $eebfdbee6f102beb$export$d9ff7c1a1cd87d12 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(4);
    const { closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const location = (0, $QU6QS.useLocation)();
    const previousLocation = (0, $42omo.useRef)(location);
    let t0;
    let t1;
    if ($[0] !== closeOnlyPreviewPanel || $[1] !== location) {
        t0 = ()=>{
            const currentLocationKey = `${location.pathname}${location.search}`;
            const previousLocationKey = `${previousLocation.current.pathname}${previousLocation.current.search}`;
            if (currentLocationKey !== previousLocationKey) {
                closeOnlyPreviewPanel();
                previousLocation.current = location;
            }
        };
        t1 = [
            location,
            closeOnlyPreviewPanel
        ];
        $[0] = closeOnlyPreviewPanel;
        $[1] = location;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $42omo.useEffect)(t0, t1);
} : ()=>{
    const { closeOnlyPreviewPanel: closeOnlyPreviewPanel } = (0, $8wJwv.useClosePreviewPanel)();
    const location = (0, $QU6QS.useLocation)();
    const previousLocation = (0, $42omo.useRef)(location);
    (0, $42omo.useEffect)(()=>{
        // Check if location has actually changed (excluding hash for same-page navigation)
        const currentLocationKey = `${location.pathname}${location.search}`;
        const previousLocationKey = `${previousLocation.current.pathname}${previousLocation.current.search}`;
        if (currentLocationKey !== previousLocationKey) {
            // closeOnlyPreviewPanel already includes the check for open panels
            closeOnlyPreviewPanel();
            // Update the previous location reference
            previousLocation.current = location;
        }
    }, [
        location,
        closeOnlyPreviewPanel
    ]);
};
module.exports["useClosePreviewPanelOnUrlChange"] = $eebfdbee6f102beb$export$d9ff7c1a1cd87d12;

});

parcelRegister("8wJwv", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $4BDAe = parcelRequire("4BDAe");


var $fN3iy = parcelRequire("fN3iy");


var $9wGTI = parcelRequire("9wGTI");


var $jln20 = parcelRequire("jln20");


var $aWwYt = parcelRequire("aWwYt");

const $973f6037ca005097$export$aedf9e3a5c7d9cd = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const { closeAll: closeAll } = (0, $jln20.useRightSidebarContext)();
    let t0;
    if ($[0] !== hideObjectSidebar) {
        t0 = ()=>{
            window.dispatchEvent(new Event("closeGlobalSidebar"));
            if ((0, $9wGTI.fg)("confluence_frontend_content_wrapper")) hideObjectSidebar();
        };
        $[0] = hideObjectSidebar;
        $[1] = t0;
    } else t0 = $[1];
    const closeObjectSidebar = t0;
    let t1;
    if ($[2] !== close || $[3] !== context?.state?.panel) {
        t1 = (onClose)=>{
            if (context?.state?.panel) close(onClose);
        };
        $[2] = close;
        $[3] = context?.state?.panel;
        $[4] = t1;
    } else t1 = $[4];
    const closeOnlyPreviewPanel = t1;
    let t2;
    if ($[5] !== closeAll || $[6] !== closeObjectSidebar) {
        t2 = ()=>{
            closeAll();
            closeObjectSidebar();
        };
        $[5] = closeAll;
        $[6] = closeObjectSidebar;
        $[7] = t2;
    } else t2 = $[7];
    const closeAllPanels = t2;
    let t3;
    if ($[8] !== closeAllPanels || $[9] !== closeOnlyPreviewPanel) {
        t3 = {
            closeAllPanels: closeAllPanels,
            closeOnlyPreviewPanel: closeOnlyPreviewPanel
        };
        $[8] = closeAllPanels;
        $[9] = closeOnlyPreviewPanel;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ()=>{
    const context = (0, $fN3iy.usePreviewPanelsContext)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: close } = (0, $4BDAe.usePreviewPanelsActions)();
    const { closeAll: closeAll } = (0, $jln20.useRightSidebarContext)();
    const closeObjectSidebar = ()=>{
        window.dispatchEvent(new Event('closeGlobalSidebar'));
        if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) hideObjectSidebar();
    };
    const closeOnlyPreviewPanel = (onClose)=>{
        if (context?.state?.panel) close(onClose);
    };
    const closeAllPanels = ()=>{
        closeAll();
        closeObjectSidebar();
    };
    return {
        closeAllPanels: closeAllPanels,
        closeOnlyPreviewPanel: closeOnlyPreviewPanel
    };
};
module.exports["useClosePreviewPanel"] = $973f6037ca005097$export$aedf9e3a5c7d9cd;

});

parcelRegister("ln0hx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $42omo.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("5zeiq"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("e12nd"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("7jzRs"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("WZXzq"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("8HWbg"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("gftm0"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("i45Q4"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("7F0EU"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("dkdoA"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("fiWku"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("jUtZg"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("8OD5y"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("5zeiq", function(module, exports) {

let $40db4f953ace2082$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $40db4f953ace2082$var$load("2YffH"),
    $40db4f953ace2082$var$load("gNfuQ"),
    $40db4f953ace2082$var$load("eNXrl"),
    $40db4f953ace2082$var$load("h6MOP"),
    $40db4f953ace2082$var$load("gaF3h"),
    $40db4f953ace2082$var$load("dZsGY"),
    $40db4f953ace2082$var$load("d2YjW"),
    $40db4f953ace2082$var$load("eBRUf"),
    $40db4f953ace2082$var$load("jWHz7"),
    $40db4f953ace2082$var$load("7o9KM"),
    $40db4f953ace2082$var$load("hUmZG"),
    $40db4f953ace2082$var$load("h4Nf7"),
    $40db4f953ace2082$var$load("8YSo7"),
    $40db4f953ace2082$var$load("h9S8v"),
    $40db4f953ace2082$var$load("dl2qY"),
    $40db4f953ace2082$var$load("kL5FA"),
    $40db4f953ace2082$var$load("7aMek"),
    $40db4f953ace2082$var$load("g4qer"),
    $40db4f953ace2082$var$load("3GuOt"),
    $40db4f953ace2082$var$load("jbM5v"),
    $40db4f953ace2082$var$load("dek7I"),
    $40db4f953ace2082$var$load("dYtBN"),
    $40db4f953ace2082$var$load("kNV5Y"),
    $40db4f953ace2082$var$load("6SWFK"),
    $40db4f953ace2082$var$load("5zapo"),
    $40db4f953ace2082$var$load("3MYQs"),
    $40db4f953ace2082$var$load("9atVd"),
    $40db4f953ace2082$var$load("6wr18"),
    $40db4f953ace2082$var$load("gT8XU"),
    $40db4f953ace2082$var$load("53AGa"),
    $40db4f953ace2082$var$load("8bhm4"),
    $40db4f953ace2082$var$load("5wVuh"),
    $40db4f953ace2082$var$load("4NznW"),
    $40db4f953ace2082$var$load("7hmKj"),
    $40db4f953ace2082$var$load("14Bh4"),
    $40db4f953ace2082$var$load("2tIxk"),
    $40db4f953ace2082$var$load("dLq4a"),
    $40db4f953ace2082$var$load("ffEVr"),
    $40db4f953ace2082$var$load("aQh37"),
    $40db4f953ace2082$var$load("bJVDE"),
    $40db4f953ace2082$var$load("4XdkL"),
    $40db4f953ace2082$var$load("4eock"),
    $40db4f953ace2082$var$load("8k9aB"),
    $40db4f953ace2082$var$load("fLwVm"),
    $40db4f953ace2082$var$load("1bbSu"),
    $40db4f953ace2082$var$load("kuFG2"),
    $40db4f953ace2082$var$load("b9CA3"),
    $40db4f953ace2082$var$load("Wowvf"),
    $40db4f953ace2082$var$load("jf18J"),
    $40db4f953ace2082$var$load("1F2Py"),
    $40db4f953ace2082$var$load("lJ0p6"),
    $40db4f953ace2082$var$load("cjaF7"),
    $40db4f953ace2082$var$load("hhss7"),
    $40db4f953ace2082$var$load("fuks3"),
    $40db4f953ace2082$var$load("lnKog"),
    $40db4f953ace2082$var$load("h3ABO"),
    $40db4f953ace2082$var$load("kC80R"),
    $40db4f953ace2082$var$load("7EorR"),
    $40db4f953ace2082$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("e12nd", function(module, exports) {

let $a343000686fba24a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a343000686fba24a$var$load("2YffH"),
    $a343000686fba24a$var$load("gNfuQ"),
    $a343000686fba24a$var$load("eNXrl"),
    $a343000686fba24a$var$load("h6MOP"),
    $a343000686fba24a$var$load("gaF3h"),
    $a343000686fba24a$var$load("dZsGY"),
    $a343000686fba24a$var$load("d2YjW"),
    $a343000686fba24a$var$load("eBRUf"),
    $a343000686fba24a$var$load("jWHz7"),
    $a343000686fba24a$var$load("7o9KM"),
    $a343000686fba24a$var$load("hUmZG"),
    $a343000686fba24a$var$load("h4Nf7"),
    $a343000686fba24a$var$load("8YSo7"),
    $a343000686fba24a$var$load("h9S8v"),
    $a343000686fba24a$var$load("dl2qY"),
    $a343000686fba24a$var$load("kL5FA"),
    $a343000686fba24a$var$load("7aMek"),
    $a343000686fba24a$var$load("g4qer"),
    $a343000686fba24a$var$load("3GuOt"),
    $a343000686fba24a$var$load("jbM5v"),
    $a343000686fba24a$var$load("dek7I"),
    $a343000686fba24a$var$load("dYtBN"),
    $a343000686fba24a$var$load("kNV5Y"),
    $a343000686fba24a$var$load("6SWFK"),
    $a343000686fba24a$var$load("5zapo"),
    $a343000686fba24a$var$load("3MYQs"),
    $a343000686fba24a$var$load("9atVd"),
    $a343000686fba24a$var$load("6wr18"),
    $a343000686fba24a$var$load("gT8XU"),
    $a343000686fba24a$var$load("53AGa"),
    $a343000686fba24a$var$load("8bhm4"),
    $a343000686fba24a$var$load("5wVuh"),
    $a343000686fba24a$var$load("4NznW"),
    $a343000686fba24a$var$load("7hmKj"),
    $a343000686fba24a$var$load("14Bh4"),
    $a343000686fba24a$var$load("2tIxk"),
    $a343000686fba24a$var$load("dLq4a"),
    $a343000686fba24a$var$load("ffEVr"),
    $a343000686fba24a$var$load("aQh37"),
    $a343000686fba24a$var$load("bJVDE"),
    $a343000686fba24a$var$load("4XdkL"),
    $a343000686fba24a$var$load("4eock"),
    $a343000686fba24a$var$load("8k9aB"),
    $a343000686fba24a$var$load("fLwVm"),
    $a343000686fba24a$var$load("1bbSu"),
    $a343000686fba24a$var$load("kuFG2"),
    $a343000686fba24a$var$load("b9CA3"),
    $a343000686fba24a$var$load("Wowvf"),
    $a343000686fba24a$var$load("jf18J"),
    $a343000686fba24a$var$load("1F2Py"),
    $a343000686fba24a$var$load("lJ0p6"),
    $a343000686fba24a$var$load("cjaF7"),
    $a343000686fba24a$var$load("hhss7"),
    $a343000686fba24a$var$load("fuks3"),
    $a343000686fba24a$var$load("lnKog"),
    $a343000686fba24a$var$load("h3ABO"),
    $a343000686fba24a$var$load("kC80R"),
    $a343000686fba24a$var$load("7EorR"),
    $a343000686fba24a$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("7jzRs", function(module, exports) {

let $5536200644646081$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5536200644646081$var$load("2YffH"),
    $5536200644646081$var$load("gNfuQ"),
    $5536200644646081$var$load("eNXrl"),
    $5536200644646081$var$load("h6MOP"),
    $5536200644646081$var$load("gaF3h"),
    $5536200644646081$var$load("dZsGY"),
    $5536200644646081$var$load("d2YjW"),
    $5536200644646081$var$load("eBRUf"),
    $5536200644646081$var$load("jWHz7"),
    $5536200644646081$var$load("7o9KM"),
    $5536200644646081$var$load("hUmZG"),
    $5536200644646081$var$load("h4Nf7"),
    $5536200644646081$var$load("8YSo7"),
    $5536200644646081$var$load("h9S8v"),
    $5536200644646081$var$load("dl2qY"),
    $5536200644646081$var$load("kL5FA"),
    $5536200644646081$var$load("7aMek"),
    $5536200644646081$var$load("g4qer"),
    $5536200644646081$var$load("3GuOt"),
    $5536200644646081$var$load("jbM5v"),
    $5536200644646081$var$load("dek7I"),
    $5536200644646081$var$load("dYtBN"),
    $5536200644646081$var$load("kNV5Y"),
    $5536200644646081$var$load("6SWFK"),
    $5536200644646081$var$load("5zapo"),
    $5536200644646081$var$load("3MYQs"),
    $5536200644646081$var$load("9atVd"),
    $5536200644646081$var$load("6wr18"),
    $5536200644646081$var$load("gT8XU"),
    $5536200644646081$var$load("53AGa"),
    $5536200644646081$var$load("8bhm4"),
    $5536200644646081$var$load("5wVuh"),
    $5536200644646081$var$load("4NznW"),
    $5536200644646081$var$load("7hmKj"),
    $5536200644646081$var$load("14Bh4"),
    $5536200644646081$var$load("2tIxk"),
    $5536200644646081$var$load("dLq4a"),
    $5536200644646081$var$load("ffEVr"),
    $5536200644646081$var$load("aQh37"),
    $5536200644646081$var$load("bJVDE"),
    $5536200644646081$var$load("4XdkL"),
    $5536200644646081$var$load("4eock"),
    $5536200644646081$var$load("8k9aB"),
    $5536200644646081$var$load("fLwVm"),
    $5536200644646081$var$load("1bbSu"),
    $5536200644646081$var$load("kuFG2"),
    $5536200644646081$var$load("b9CA3"),
    $5536200644646081$var$load("Wowvf"),
    $5536200644646081$var$load("jf18J"),
    $5536200644646081$var$load("1F2Py"),
    $5536200644646081$var$load("lJ0p6"),
    $5536200644646081$var$load("cjaF7"),
    $5536200644646081$var$load("hhss7"),
    $5536200644646081$var$load("fuks3"),
    $5536200644646081$var$load("lnKog"),
    $5536200644646081$var$load("h3ABO"),
    $5536200644646081$var$load("kC80R"),
    $5536200644646081$var$load("7EorR"),
    $5536200644646081$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("WZXzq", function(module, exports) {

let $0b157ad29ce29e08$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0b157ad29ce29e08$var$load("8k9aB"),
    $0b157ad29ce29e08$var$load("fLwVm"),
    $0b157ad29ce29e08$var$load("2YffH"),
    $0b157ad29ce29e08$var$load("h6MOP"),
    $0b157ad29ce29e08$var$load("gaF3h"),
    $0b157ad29ce29e08$var$load("d2YjW"),
    $0b157ad29ce29e08$var$load("eBRUf"),
    $0b157ad29ce29e08$var$load("jWHz7"),
    $0b157ad29ce29e08$var$load("7o9KM"),
    $0b157ad29ce29e08$var$load("hUmZG"),
    $0b157ad29ce29e08$var$load("h4Nf7"),
    $0b157ad29ce29e08$var$load("8YSo7"),
    $0b157ad29ce29e08$var$load("dl2qY"),
    $0b157ad29ce29e08$var$load("kL5FA"),
    $0b157ad29ce29e08$var$load("7aMek"),
    $0b157ad29ce29e08$var$load("g4qer"),
    $0b157ad29ce29e08$var$load("3GuOt"),
    $0b157ad29ce29e08$var$load("jbM5v"),
    $0b157ad29ce29e08$var$load("6SWFK"),
    $0b157ad29ce29e08$var$load("5zapo"),
    $0b157ad29ce29e08$var$load("3MYQs"),
    $0b157ad29ce29e08$var$load("6wr18"),
    $0b157ad29ce29e08$var$load("9atVd"),
    $0b157ad29ce29e08$var$load("53AGa"),
    $0b157ad29ce29e08$var$load("8bhm4"),
    $0b157ad29ce29e08$var$load("7hmKj"),
    $0b157ad29ce29e08$var$load("14Bh4"),
    $0b157ad29ce29e08$var$load("2tIxk"),
    $0b157ad29ce29e08$var$load("dLq4a"),
    $0b157ad29ce29e08$var$load("ffEVr"),
    $0b157ad29ce29e08$var$load("aQh37"),
    $0b157ad29ce29e08$var$load("bJVDE"),
    $0b157ad29ce29e08$var$load("4XdkL"),
    $0b157ad29ce29e08$var$load("4eock"),
    $0b157ad29ce29e08$var$load("1bbSu"),
    $0b157ad29ce29e08$var$load("kuFG2"),
    $0b157ad29ce29e08$var$load("fuks3"),
    $0b157ad29ce29e08$var$load("b9CA3"),
    $0b157ad29ce29e08$var$load("Wowvf"),
    $0b157ad29ce29e08$var$load("jf18J"),
    $0b157ad29ce29e08$var$load("1F2Py"),
    $0b157ad29ce29e08$var$load("lJ0p6"),
    $0b157ad29ce29e08$var$load("cjaF7"),
    $0b157ad29ce29e08$var$load("hhss7"),
    $0b157ad29ce29e08$var$load("h3ABO"),
    $0b157ad29ce29e08$var$load("kC80R"),
    $0b157ad29ce29e08$var$load("7EorR"),
    $0b157ad29ce29e08$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("8HWbg", function(module, exports) {

let $656f7857fa1eca95$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $656f7857fa1eca95$var$load("8k9aB"),
    $656f7857fa1eca95$var$load("fLwVm"),
    $656f7857fa1eca95$var$load("2YffH"),
    $656f7857fa1eca95$var$load("h6MOP"),
    $656f7857fa1eca95$var$load("gaF3h"),
    $656f7857fa1eca95$var$load("d2YjW"),
    $656f7857fa1eca95$var$load("eBRUf"),
    $656f7857fa1eca95$var$load("jWHz7"),
    $656f7857fa1eca95$var$load("7o9KM"),
    $656f7857fa1eca95$var$load("hUmZG"),
    $656f7857fa1eca95$var$load("h4Nf7"),
    $656f7857fa1eca95$var$load("8YSo7"),
    $656f7857fa1eca95$var$load("dl2qY"),
    $656f7857fa1eca95$var$load("kL5FA"),
    $656f7857fa1eca95$var$load("7aMek"),
    $656f7857fa1eca95$var$load("g4qer"),
    $656f7857fa1eca95$var$load("3GuOt"),
    $656f7857fa1eca95$var$load("jbM5v"),
    $656f7857fa1eca95$var$load("6SWFK"),
    $656f7857fa1eca95$var$load("5zapo"),
    $656f7857fa1eca95$var$load("3MYQs"),
    $656f7857fa1eca95$var$load("6wr18"),
    $656f7857fa1eca95$var$load("9atVd"),
    $656f7857fa1eca95$var$load("53AGa"),
    $656f7857fa1eca95$var$load("8bhm4"),
    $656f7857fa1eca95$var$load("7hmKj"),
    $656f7857fa1eca95$var$load("14Bh4"),
    $656f7857fa1eca95$var$load("2tIxk"),
    $656f7857fa1eca95$var$load("dLq4a"),
    $656f7857fa1eca95$var$load("ffEVr"),
    $656f7857fa1eca95$var$load("aQh37"),
    $656f7857fa1eca95$var$load("bJVDE"),
    $656f7857fa1eca95$var$load("4XdkL"),
    $656f7857fa1eca95$var$load("4eock"),
    $656f7857fa1eca95$var$load("1bbSu"),
    $656f7857fa1eca95$var$load("kuFG2"),
    $656f7857fa1eca95$var$load("fuks3"),
    $656f7857fa1eca95$var$load("b9CA3"),
    $656f7857fa1eca95$var$load("Wowvf"),
    $656f7857fa1eca95$var$load("jf18J"),
    $656f7857fa1eca95$var$load("1F2Py"),
    $656f7857fa1eca95$var$load("lJ0p6"),
    $656f7857fa1eca95$var$load("cjaF7"),
    $656f7857fa1eca95$var$load("hhss7"),
    $656f7857fa1eca95$var$load("h3ABO"),
    $656f7857fa1eca95$var$load("kC80R"),
    $656f7857fa1eca95$var$load("7EorR"),
    $656f7857fa1eca95$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("gftm0", function(module, exports) {

let $bd44d12617271172$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bd44d12617271172$var$load("8k9aB"),
    $bd44d12617271172$var$load("fLwVm"),
    $bd44d12617271172$var$load("2YffH"),
    $bd44d12617271172$var$load("h6MOP"),
    $bd44d12617271172$var$load("gaF3h"),
    $bd44d12617271172$var$load("d2YjW"),
    $bd44d12617271172$var$load("eBRUf"),
    $bd44d12617271172$var$load("jWHz7"),
    $bd44d12617271172$var$load("7o9KM"),
    $bd44d12617271172$var$load("hUmZG"),
    $bd44d12617271172$var$load("h4Nf7"),
    $bd44d12617271172$var$load("8YSo7"),
    $bd44d12617271172$var$load("dl2qY"),
    $bd44d12617271172$var$load("kL5FA"),
    $bd44d12617271172$var$load("7aMek"),
    $bd44d12617271172$var$load("g4qer"),
    $bd44d12617271172$var$load("3GuOt"),
    $bd44d12617271172$var$load("jbM5v"),
    $bd44d12617271172$var$load("6SWFK"),
    $bd44d12617271172$var$load("5zapo"),
    $bd44d12617271172$var$load("3MYQs"),
    $bd44d12617271172$var$load("6wr18"),
    $bd44d12617271172$var$load("9atVd"),
    $bd44d12617271172$var$load("53AGa"),
    $bd44d12617271172$var$load("8bhm4"),
    $bd44d12617271172$var$load("7hmKj"),
    $bd44d12617271172$var$load("14Bh4"),
    $bd44d12617271172$var$load("2tIxk"),
    $bd44d12617271172$var$load("dLq4a"),
    $bd44d12617271172$var$load("ffEVr"),
    $bd44d12617271172$var$load("aQh37"),
    $bd44d12617271172$var$load("bJVDE"),
    $bd44d12617271172$var$load("4XdkL"),
    $bd44d12617271172$var$load("4eock"),
    $bd44d12617271172$var$load("1bbSu"),
    $bd44d12617271172$var$load("kuFG2"),
    $bd44d12617271172$var$load("fuks3"),
    $bd44d12617271172$var$load("b9CA3"),
    $bd44d12617271172$var$load("Wowvf"),
    $bd44d12617271172$var$load("jf18J"),
    $bd44d12617271172$var$load("1F2Py"),
    $bd44d12617271172$var$load("lJ0p6"),
    $bd44d12617271172$var$load("cjaF7"),
    $bd44d12617271172$var$load("hhss7"),
    $bd44d12617271172$var$load("h3ABO"),
    $bd44d12617271172$var$load("kC80R"),
    $bd44d12617271172$var$load("7EorR"),
    $bd44d12617271172$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("i45Q4", function(module, exports) {

let $d26d21352b041959$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d26d21352b041959$var$load("8k9aB"),
    $d26d21352b041959$var$load("fLwVm"),
    $d26d21352b041959$var$load("2YffH"),
    $d26d21352b041959$var$load("h6MOP"),
    $d26d21352b041959$var$load("gaF3h"),
    $d26d21352b041959$var$load("d2YjW"),
    $d26d21352b041959$var$load("eBRUf"),
    $d26d21352b041959$var$load("jWHz7"),
    $d26d21352b041959$var$load("7o9KM"),
    $d26d21352b041959$var$load("hUmZG"),
    $d26d21352b041959$var$load("h4Nf7"),
    $d26d21352b041959$var$load("8YSo7"),
    $d26d21352b041959$var$load("dl2qY"),
    $d26d21352b041959$var$load("kL5FA"),
    $d26d21352b041959$var$load("7aMek"),
    $d26d21352b041959$var$load("g4qer"),
    $d26d21352b041959$var$load("3GuOt"),
    $d26d21352b041959$var$load("jbM5v"),
    $d26d21352b041959$var$load("6SWFK"),
    $d26d21352b041959$var$load("5zapo"),
    $d26d21352b041959$var$load("3MYQs"),
    $d26d21352b041959$var$load("6wr18"),
    $d26d21352b041959$var$load("9atVd"),
    $d26d21352b041959$var$load("53AGa"),
    $d26d21352b041959$var$load("8bhm4"),
    $d26d21352b041959$var$load("7hmKj"),
    $d26d21352b041959$var$load("14Bh4"),
    $d26d21352b041959$var$load("2tIxk"),
    $d26d21352b041959$var$load("dLq4a"),
    $d26d21352b041959$var$load("ffEVr"),
    $d26d21352b041959$var$load("aQh37"),
    $d26d21352b041959$var$load("bJVDE"),
    $d26d21352b041959$var$load("4XdkL"),
    $d26d21352b041959$var$load("4eock"),
    $d26d21352b041959$var$load("1bbSu"),
    $d26d21352b041959$var$load("kuFG2"),
    $d26d21352b041959$var$load("b9CA3"),
    $d26d21352b041959$var$load("Wowvf"),
    $d26d21352b041959$var$load("jf18J"),
    $d26d21352b041959$var$load("1F2Py"),
    $d26d21352b041959$var$load("lJ0p6"),
    $d26d21352b041959$var$load("cjaF7"),
    $d26d21352b041959$var$load("hhss7"),
    $d26d21352b041959$var$load("fuks3"),
    $d26d21352b041959$var$load("lnKog"),
    $d26d21352b041959$var$load("h3ABO"),
    $d26d21352b041959$var$load("kC80R"),
    $d26d21352b041959$var$load("7EorR"),
    $d26d21352b041959$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("7F0EU", function(module, exports) {

let $593cdf94fdc6c9a5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $593cdf94fdc6c9a5$var$load("2YffH"),
    $593cdf94fdc6c9a5$var$load("h6MOP"),
    $593cdf94fdc6c9a5$var$load("gaF3h"),
    $593cdf94fdc6c9a5$var$load("dZsGY"),
    $593cdf94fdc6c9a5$var$load("d2YjW"),
    $593cdf94fdc6c9a5$var$load("eBRUf"),
    $593cdf94fdc6c9a5$var$load("jWHz7"),
    $593cdf94fdc6c9a5$var$load("7o9KM"),
    $593cdf94fdc6c9a5$var$load("hUmZG"),
    $593cdf94fdc6c9a5$var$load("h4Nf7"),
    $593cdf94fdc6c9a5$var$load("8YSo7"),
    $593cdf94fdc6c9a5$var$load("h9S8v"),
    $593cdf94fdc6c9a5$var$load("dl2qY"),
    $593cdf94fdc6c9a5$var$load("kL5FA"),
    $593cdf94fdc6c9a5$var$load("7aMek"),
    $593cdf94fdc6c9a5$var$load("g4qer"),
    $593cdf94fdc6c9a5$var$load("3GuOt"),
    $593cdf94fdc6c9a5$var$load("jbM5v"),
    $593cdf94fdc6c9a5$var$load("dek7I"),
    $593cdf94fdc6c9a5$var$load("dYtBN"),
    $593cdf94fdc6c9a5$var$load("kNV5Y"),
    $593cdf94fdc6c9a5$var$load("6SWFK"),
    $593cdf94fdc6c9a5$var$load("5zapo"),
    $593cdf94fdc6c9a5$var$load("3MYQs"),
    $593cdf94fdc6c9a5$var$load("9atVd"),
    $593cdf94fdc6c9a5$var$load("6wr18"),
    $593cdf94fdc6c9a5$var$load("gT8XU"),
    $593cdf94fdc6c9a5$var$load("53AGa"),
    $593cdf94fdc6c9a5$var$load("8bhm4"),
    $593cdf94fdc6c9a5$var$load("5wVuh"),
    $593cdf94fdc6c9a5$var$load("4NznW"),
    $593cdf94fdc6c9a5$var$load("7hmKj"),
    $593cdf94fdc6c9a5$var$load("14Bh4"),
    $593cdf94fdc6c9a5$var$load("2tIxk"),
    $593cdf94fdc6c9a5$var$load("dLq4a"),
    $593cdf94fdc6c9a5$var$load("ffEVr"),
    $593cdf94fdc6c9a5$var$load("aQh37"),
    $593cdf94fdc6c9a5$var$load("bJVDE"),
    $593cdf94fdc6c9a5$var$load("4XdkL"),
    $593cdf94fdc6c9a5$var$load("4eock"),
    $593cdf94fdc6c9a5$var$load("8k9aB"),
    $593cdf94fdc6c9a5$var$load("fLwVm"),
    $593cdf94fdc6c9a5$var$load("1bbSu"),
    $593cdf94fdc6c9a5$var$load("kuFG2"),
    $593cdf94fdc6c9a5$var$load("b9CA3"),
    $593cdf94fdc6c9a5$var$load("Wowvf"),
    $593cdf94fdc6c9a5$var$load("jf18J"),
    $593cdf94fdc6c9a5$var$load("1F2Py"),
    $593cdf94fdc6c9a5$var$load("lJ0p6"),
    $593cdf94fdc6c9a5$var$load("cjaF7"),
    $593cdf94fdc6c9a5$var$load("hhss7"),
    $593cdf94fdc6c9a5$var$load("fuks3"),
    $593cdf94fdc6c9a5$var$load("lnKog"),
    $593cdf94fdc6c9a5$var$load("h3ABO"),
    $593cdf94fdc6c9a5$var$load("kC80R"),
    $593cdf94fdc6c9a5$var$load("7EorR"),
    $593cdf94fdc6c9a5$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("dkdoA", function(module, exports) {

let $9b3788b59361c2a6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9b3788b59361c2a6$var$load("2YffH"),
    $9b3788b59361c2a6$var$load("h6MOP"),
    $9b3788b59361c2a6$var$load("gaF3h"),
    $9b3788b59361c2a6$var$load("dZsGY"),
    $9b3788b59361c2a6$var$load("d2YjW"),
    $9b3788b59361c2a6$var$load("eBRUf"),
    $9b3788b59361c2a6$var$load("jWHz7"),
    $9b3788b59361c2a6$var$load("7o9KM"),
    $9b3788b59361c2a6$var$load("hUmZG"),
    $9b3788b59361c2a6$var$load("h4Nf7"),
    $9b3788b59361c2a6$var$load("8YSo7"),
    $9b3788b59361c2a6$var$load("h9S8v"),
    $9b3788b59361c2a6$var$load("dl2qY"),
    $9b3788b59361c2a6$var$load("kL5FA"),
    $9b3788b59361c2a6$var$load("7aMek"),
    $9b3788b59361c2a6$var$load("g4qer"),
    $9b3788b59361c2a6$var$load("3GuOt"),
    $9b3788b59361c2a6$var$load("jbM5v"),
    $9b3788b59361c2a6$var$load("dek7I"),
    $9b3788b59361c2a6$var$load("dYtBN"),
    $9b3788b59361c2a6$var$load("kNV5Y"),
    $9b3788b59361c2a6$var$load("6SWFK"),
    $9b3788b59361c2a6$var$load("5zapo"),
    $9b3788b59361c2a6$var$load("3MYQs"),
    $9b3788b59361c2a6$var$load("9atVd"),
    $9b3788b59361c2a6$var$load("6wr18"),
    $9b3788b59361c2a6$var$load("gT8XU"),
    $9b3788b59361c2a6$var$load("53AGa"),
    $9b3788b59361c2a6$var$load("8bhm4"),
    $9b3788b59361c2a6$var$load("5wVuh"),
    $9b3788b59361c2a6$var$load("4NznW"),
    $9b3788b59361c2a6$var$load("7hmKj"),
    $9b3788b59361c2a6$var$load("14Bh4"),
    $9b3788b59361c2a6$var$load("2tIxk"),
    $9b3788b59361c2a6$var$load("dLq4a"),
    $9b3788b59361c2a6$var$load("ffEVr"),
    $9b3788b59361c2a6$var$load("aQh37"),
    $9b3788b59361c2a6$var$load("bJVDE"),
    $9b3788b59361c2a6$var$load("4XdkL"),
    $9b3788b59361c2a6$var$load("4eock"),
    $9b3788b59361c2a6$var$load("8k9aB"),
    $9b3788b59361c2a6$var$load("fLwVm"),
    $9b3788b59361c2a6$var$load("1bbSu"),
    $9b3788b59361c2a6$var$load("kuFG2"),
    $9b3788b59361c2a6$var$load("b9CA3"),
    $9b3788b59361c2a6$var$load("Wowvf"),
    $9b3788b59361c2a6$var$load("jf18J"),
    $9b3788b59361c2a6$var$load("1F2Py"),
    $9b3788b59361c2a6$var$load("lJ0p6"),
    $9b3788b59361c2a6$var$load("cjaF7"),
    $9b3788b59361c2a6$var$load("hhss7"),
    $9b3788b59361c2a6$var$load("fuks3"),
    $9b3788b59361c2a6$var$load("lnKog"),
    $9b3788b59361c2a6$var$load("h3ABO"),
    $9b3788b59361c2a6$var$load("kC80R"),
    $9b3788b59361c2a6$var$load("7EorR"),
    $9b3788b59361c2a6$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("fiWku", function(module, exports) {

let $b245c87f9f513e58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b245c87f9f513e58$var$load("8k9aB"),
    $b245c87f9f513e58$var$load("fLwVm"),
    $b245c87f9f513e58$var$load("2YffH"),
    $b245c87f9f513e58$var$load("h6MOP"),
    $b245c87f9f513e58$var$load("gaF3h"),
    $b245c87f9f513e58$var$load("d2YjW"),
    $b245c87f9f513e58$var$load("eBRUf"),
    $b245c87f9f513e58$var$load("jWHz7"),
    $b245c87f9f513e58$var$load("7o9KM"),
    $b245c87f9f513e58$var$load("hUmZG"),
    $b245c87f9f513e58$var$load("h4Nf7"),
    $b245c87f9f513e58$var$load("8YSo7"),
    $b245c87f9f513e58$var$load("dl2qY"),
    $b245c87f9f513e58$var$load("kL5FA"),
    $b245c87f9f513e58$var$load("7aMek"),
    $b245c87f9f513e58$var$load("g4qer"),
    $b245c87f9f513e58$var$load("3GuOt"),
    $b245c87f9f513e58$var$load("jbM5v"),
    $b245c87f9f513e58$var$load("6SWFK"),
    $b245c87f9f513e58$var$load("5zapo"),
    $b245c87f9f513e58$var$load("3MYQs"),
    $b245c87f9f513e58$var$load("6wr18"),
    $b245c87f9f513e58$var$load("9atVd"),
    $b245c87f9f513e58$var$load("53AGa"),
    $b245c87f9f513e58$var$load("8bhm4"),
    $b245c87f9f513e58$var$load("7hmKj"),
    $b245c87f9f513e58$var$load("14Bh4"),
    $b245c87f9f513e58$var$load("2tIxk"),
    $b245c87f9f513e58$var$load("dLq4a"),
    $b245c87f9f513e58$var$load("ffEVr"),
    $b245c87f9f513e58$var$load("aQh37"),
    $b245c87f9f513e58$var$load("bJVDE"),
    $b245c87f9f513e58$var$load("4XdkL"),
    $b245c87f9f513e58$var$load("4eock"),
    $b245c87f9f513e58$var$load("1bbSu"),
    $b245c87f9f513e58$var$load("kuFG2"),
    $b245c87f9f513e58$var$load("fuks3"),
    $b245c87f9f513e58$var$load("b9CA3"),
    $b245c87f9f513e58$var$load("Wowvf"),
    $b245c87f9f513e58$var$load("jf18J"),
    $b245c87f9f513e58$var$load("1F2Py"),
    $b245c87f9f513e58$var$load("lJ0p6"),
    $b245c87f9f513e58$var$load("cjaF7"),
    $b245c87f9f513e58$var$load("hhss7"),
    $b245c87f9f513e58$var$load("h3ABO"),
    $b245c87f9f513e58$var$load("kC80R"),
    $b245c87f9f513e58$var$load("7EorR"),
    $b245c87f9f513e58$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("jUtZg", function(module, exports) {

let $e7ea821750d36c4c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e7ea821750d36c4c$var$load("8k9aB"),
    $e7ea821750d36c4c$var$load("fLwVm"),
    $e7ea821750d36c4c$var$load("2YffH"),
    $e7ea821750d36c4c$var$load("h6MOP"),
    $e7ea821750d36c4c$var$load("gaF3h"),
    $e7ea821750d36c4c$var$load("d2YjW"),
    $e7ea821750d36c4c$var$load("eBRUf"),
    $e7ea821750d36c4c$var$load("jWHz7"),
    $e7ea821750d36c4c$var$load("7o9KM"),
    $e7ea821750d36c4c$var$load("hUmZG"),
    $e7ea821750d36c4c$var$load("h4Nf7"),
    $e7ea821750d36c4c$var$load("8YSo7"),
    $e7ea821750d36c4c$var$load("dl2qY"),
    $e7ea821750d36c4c$var$load("kL5FA"),
    $e7ea821750d36c4c$var$load("7aMek"),
    $e7ea821750d36c4c$var$load("g4qer"),
    $e7ea821750d36c4c$var$load("3GuOt"),
    $e7ea821750d36c4c$var$load("jbM5v"),
    $e7ea821750d36c4c$var$load("6SWFK"),
    $e7ea821750d36c4c$var$load("5zapo"),
    $e7ea821750d36c4c$var$load("3MYQs"),
    $e7ea821750d36c4c$var$load("6wr18"),
    $e7ea821750d36c4c$var$load("9atVd"),
    $e7ea821750d36c4c$var$load("53AGa"),
    $e7ea821750d36c4c$var$load("8bhm4"),
    $e7ea821750d36c4c$var$load("7hmKj"),
    $e7ea821750d36c4c$var$load("14Bh4"),
    $e7ea821750d36c4c$var$load("2tIxk"),
    $e7ea821750d36c4c$var$load("dLq4a"),
    $e7ea821750d36c4c$var$load("ffEVr"),
    $e7ea821750d36c4c$var$load("aQh37"),
    $e7ea821750d36c4c$var$load("bJVDE"),
    $e7ea821750d36c4c$var$load("4XdkL"),
    $e7ea821750d36c4c$var$load("4eock"),
    $e7ea821750d36c4c$var$load("1bbSu"),
    $e7ea821750d36c4c$var$load("kuFG2"),
    $e7ea821750d36c4c$var$load("b9CA3"),
    $e7ea821750d36c4c$var$load("Wowvf"),
    $e7ea821750d36c4c$var$load("jf18J"),
    $e7ea821750d36c4c$var$load("1F2Py"),
    $e7ea821750d36c4c$var$load("lJ0p6"),
    $e7ea821750d36c4c$var$load("cjaF7"),
    $e7ea821750d36c4c$var$load("hhss7"),
    $e7ea821750d36c4c$var$load("fuks3"),
    $e7ea821750d36c4c$var$load("lnKog"),
    $e7ea821750d36c4c$var$load("h3ABO"),
    $e7ea821750d36c4c$var$load("kC80R"),
    $e7ea821750d36c4c$var$load("7EorR"),
    $e7ea821750d36c4c$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("8OD5y", function(module, exports) {

let $66b15068aa6a6689$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $66b15068aa6a6689$var$load("8k9aB"),
    $66b15068aa6a6689$var$load("fLwVm"),
    $66b15068aa6a6689$var$load("2YffH"),
    $66b15068aa6a6689$var$load("h6MOP"),
    $66b15068aa6a6689$var$load("gaF3h"),
    $66b15068aa6a6689$var$load("d2YjW"),
    $66b15068aa6a6689$var$load("eBRUf"),
    $66b15068aa6a6689$var$load("jWHz7"),
    $66b15068aa6a6689$var$load("7o9KM"),
    $66b15068aa6a6689$var$load("hUmZG"),
    $66b15068aa6a6689$var$load("h4Nf7"),
    $66b15068aa6a6689$var$load("8YSo7"),
    $66b15068aa6a6689$var$load("dl2qY"),
    $66b15068aa6a6689$var$load("kL5FA"),
    $66b15068aa6a6689$var$load("7aMek"),
    $66b15068aa6a6689$var$load("g4qer"),
    $66b15068aa6a6689$var$load("3GuOt"),
    $66b15068aa6a6689$var$load("jbM5v"),
    $66b15068aa6a6689$var$load("6SWFK"),
    $66b15068aa6a6689$var$load("5zapo"),
    $66b15068aa6a6689$var$load("3MYQs"),
    $66b15068aa6a6689$var$load("6wr18"),
    $66b15068aa6a6689$var$load("9atVd"),
    $66b15068aa6a6689$var$load("53AGa"),
    $66b15068aa6a6689$var$load("8bhm4"),
    $66b15068aa6a6689$var$load("7hmKj"),
    $66b15068aa6a6689$var$load("14Bh4"),
    $66b15068aa6a6689$var$load("2tIxk"),
    $66b15068aa6a6689$var$load("dLq4a"),
    $66b15068aa6a6689$var$load("ffEVr"),
    $66b15068aa6a6689$var$load("aQh37"),
    $66b15068aa6a6689$var$load("bJVDE"),
    $66b15068aa6a6689$var$load("4XdkL"),
    $66b15068aa6a6689$var$load("4eock"),
    $66b15068aa6a6689$var$load("1bbSu"),
    $66b15068aa6a6689$var$load("kuFG2"),
    $66b15068aa6a6689$var$load("b9CA3"),
    $66b15068aa6a6689$var$load("Wowvf"),
    $66b15068aa6a6689$var$load("jf18J"),
    $66b15068aa6a6689$var$load("1F2Py"),
    $66b15068aa6a6689$var$load("lJ0p6"),
    $66b15068aa6a6689$var$load("cjaF7"),
    $66b15068aa6a6689$var$load("hhss7"),
    $66b15068aa6a6689$var$load("fuks3"),
    $66b15068aa6a6689$var$load("lnKog"),
    $66b15068aa6a6689$var$load("h3ABO"),
    $66b15068aa6a6689$var$load("kC80R"),
    $66b15068aa6a6689$var$load("7EorR"),
    $66b15068aa6a6689$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("2ByX3"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("2ByX3", function(module, exports) {

let $1e5a2622ce104f93$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1e5a2622ce104f93$var$load("fuks3"),
    $1e5a2622ce104f93$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});


//# sourceMappingURL=MainLayout.7cb9c942.js.map
